/* Variant cards: show the name of the hovered color below the cards, and go back to the selected one on mouse out. */

const OPTION_SELECTOR = '.variant-picker__option--image';
const CARD_SELECTOR = `${OPTION_SELECTOR} .thumbnail-swatch`;

const getValueElement = (option) => option.querySelector('.variant-picker__option-info > .h-stack > span');

const getCardName = (card) => card.querySelector('.sr-only')?.textContent.trim() ?? '';

const getSelectedName = (option) => {
  const selectedCard = option.querySelector('input:checked + .thumbnail-swatch, .thumbnail-swatch.is-selected');

  return selectedCard ? getCardName(selectedCard) : '';
};

document.addEventListener('mouseover', (event) => {
  const card = event.target.closest(CARD_SELECTOR);

  if (!card) {
    return;
  }

  const valueElement = getValueElement(card.closest(OPTION_SELECTOR));

  if (valueElement) {
    valueElement.textContent = getCardName(card);
  }
});

document.addEventListener('mouseout', (event) => {
  const card = event.target.closest(CARD_SELECTOR);

  if (!card || card.contains(event.relatedTarget)) {
    return;
  }

  const option = card.closest(OPTION_SELECTOR);
  const valueElement = getValueElement(option);

  if (valueElement) {
    valueElement.textContent = getSelectedName(option);
  }
});
